<div class="deleted-container">
    <div class="modal custom-container">
        <div class="header" [ngClass]="{'cta': !(hasToken$ |async) }">
            <div class="smash-logo">
                <i class="icon-smash_icologo_chip"></i>
            </div>
            <h1 translate [innerHtml]="'MODAL_DELETED_TITLE' | translate | safeHtml"></h1>
        </div>
        <div class="body cta" *ngIf="!(hasToken$ |async)">
            <div class="section">
                <h2 translate [innerHtml]="'MODAL_CTA_TITLE' | translate | safeHtml"></h2>
                <div class="description" translate [innerHtml]="'MODAL_CTA_DESCRIPTION' | translate | safeHtml"></div>
            </div>
            <div class="section">
                <div>
                    <a class="btn-rounded dark" href="{{ 'BURGER_MENU_LINK_ABOUT' | translate }}" target="_blank" translate>MODAL_CTA_LINK_LABEL</a>
                </div>      
            </div>    
            <div class="section">                
                <p translate [innerHtml]="'MODAL_CTA_API_SDK' | translate | safeHtml" translate></p>
            </div>
        </div>
        <div class="body" *ngIf="(hasToken$ |async)">
            <div class="section">
                <div class="description">
                    {{ 'MODAL_DELETED_DESCRIPTION' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
